// Reconstructed from the supplied production build; original component names were unavailable.
import { DollarSignIcon, React, motion, useNavigate } from "../vendor/runtime.js";
import { useAdminAuth } from "../context/AdminAuthContext.jsx";
import { api } from "../services/api.js";
const PriceManagementPage = () => {
  useNavigate();
  const [e, t] = React.useState([]),
    [n, r] = React.useState({
      change_type: "increase",
      change_method: "percentage",
      change_value: "",
    }),
    [a, l] = React.useState(false),
    c = useAdminAuth(),
    d = c == null ? undefined : c.adminUser.id,
    f = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    },
    h = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    p = async () => {
      try {
        const { data: y } = await api.get("/admin/price-changes");
        t(y);
      } catch (y) {
        console.error("Error fetching price change history:", y);
      }
    };
  React.useEffect(() => {
    p();
  }, []);
  const g = async (y) => {
    if ((y.preventDefault(), !(!n.change_value || isNaN(n.change_value))))
      try {
        (l(true),
          await api.post("/admin/adjust-prices", {
            ...n,
            admin_id: d,
          }),
          p(),
          alert("Product prices adjusted successfully!"));
      } catch (v) {
        (console.error("Error adjusting prices:", v), alert("Failed to adjust prices"));
      } finally {
        l(false);
      }
  };
  return (
    <div className={"admin-page bg-gradient-to-br from-purple-50 via-purple-100 to-purple-50"}>
      <main className="admin-main">
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={f}
          className={"mb-10 relative"}
        >
          
          
          <div className={"relative"}>
            <span
              className={
                "inline-block py-1 px-3 mb-3 bg-purple-100 text-purple-800 rounded-full text-sm font-medium"
              }
            >
              {"Price Management"}
            </span>
            <h1 className={"text-3xl md:text-4xl font-bold text-gray-900 mb-2"}>
              {"Welcome back,"}{" "}
              <span
                className={
                  "bg-gradient-to-r from-purple-600 to-purple-800 bg-clip-text text-transparent"
                }
              >
                {(d == null ? undefined : d.name) || "Admin"}
              </span>
            </h1>
            <p className={"text-gray-600"}>
              {"Manage product prices and review price change history."}
            </p>
          </div>
        </motion.div>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={h}
          className={
            "bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 p-6 mb-10"
          }
        >
          <h2 className={"text-2xl font-bold text-gray-800 mb-4 flex items-center"}>
            <DollarSignIcon className={"w-6 h-6 mr-2 text-green-600"} />
            {"Adjust All Product Prices"}
          </h2>
          <form onSubmit={g} className={"grid grid-cols-1 md:grid-cols-3 gap-6"}>
            <div>
              <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                {"Change Type"}
              </label>
              <select
                value={n.change_type}
                onChange={(y) =>
                  r({
                    ...n,
                    change_type: y.target.value,
                  })
                }
                className={
                  "w-full border-2 rounded-lg border-gray-300 focus:ring-purple-500 focus:border-purple-500 text-gray-700 p-2"
                }
              >
                <option value={"increase"}>{"Increase"}</option>
                <option value={"decrease"}>{"Decrease"}</option>
              </select>
            </div>
            <div>
              <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                {"Change Method"}
              </label>
              <select
                value={n.change_method}
                onChange={(y) =>
                  r({
                    ...n,
                    change_method: y.target.value,
                  })
                }
                className={
                  "w-full rounded-lg border-2 border-gray-300 focus:ring-purple-500 focus:border-purple-500 text-gray-700 p-2"
                }
              >
                <option value={"percentage"}>{"Percentage (%)"}</option>
                <option value={"flat"}>{"Flat (₹)"}</option>
              </select>
            </div>
            <div>
              <label className={"block text-sm font-medium text-gray-700 mb-1"}>{"Value"}</label>
              <input
                type={"number"}
                step={"0.01"}
                value={n.change_value}
                onChange={(y) =>
                  r({
                    ...n,
                    change_value: y.target.value,
                  })
                }
                className={
                  "w-full rounded-lg border-2 border-gray-300 focus:ring-purple-500 focus:border-purple-500 text-gray-700 p-2"
                }
                placeholder={"Enter value"}
              />
            </div>
            <div className={"md:col-span-3 flex justify-end"}>
              <button
                type={"submit"}
                disabled={a}
                className={
                  "bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white py-3 px-6 rounded-xl font-medium transition duration-300 shadow-md"
                }
              >
                {a ? "Updating..." : "Apply Change"}
              </button>
            </div>
          </form>
        </motion.div>
        <motion.div
          initial={"hidden"}
          animate={"visible"}
          variants={f}
          className={"bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100"}
        >
          <div className={"p-6 border-b border-gray-100"}>
            <h2 className={"text-2xl font-bold text-gray-800"}>{"Price Change History"}</h2>
            <p className={"text-gray-500 text-sm mt-1"}>
              {"All recent adjustments made by admins"}
            </p>
          </div>
          {e.length > 0 ? (
            <div className={"overflow-x-auto"}>
              <table className={"min-w-full divide-y divide-gray-200"}>
                <thead className={"bg-gray-50"}>
                  <tr>
                    <th
                      className={"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"}
                    >
                      {"Date"}
                    </th>
                    <th
                      className={"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"}
                    >
                      {"Admin"}
                    </th>
                    <th
                      className={"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"}
                    >
                      {"Type"}
                    </th>
                    <th
                      className={"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"}
                    >
                      {"Method"}
                    </th>
                    <th
                      className={"px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase"}
                    >
                      {"Value"}
                    </th>
                  </tr>
                </thead>
                <tbody className={"bg-white divide-y divide-gray-200"}>
                  {e.map((y) => (
                    <tr key={y.id} className={"hover:bg-gray-50 transition duration-150"}>
                      <td className={"px-6 py-4 text-sm text-gray-600"}>
                        {new Date(y.applied_at).toLocaleDateString()}
                      </td>
                      <td className={"px-6 py-4 text-sm font-medium text-gray-900"}>
                        {y.admin_name || "Admin"}
                      </td>
                      <td className={"px-6 py-4 text-sm text-gray-700"}>{y.change_type}</td>
                      <td className={"px-6 py-4 text-sm text-gray-700"}>{y.change_method}</td>
                      <td className={"px-6 py-4 text-sm text-gray-700"}>
                        {y.change_method === "percentage"
                          ? `${y.change_value}%`
                          : `₹${y.change_value}`}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className={"p-8 text-center text-gray-500"}>
              {"No price change history found."}
            </div>
          )}
        </motion.div>
      </main>
    </div>
  );
};
export { PriceManagementPage };
